module.exports = __webpack_public_path__ + "img/info.b88ad06d.svg";